module.exports = __webpack_public_path__ + "img/Weapon_114.f1649ca0.png";